// Обмен сообщениями с родительским приложением, в которое календарь встроен через iframe.
// Протокол:
//   календарь → родитель: { source: 'medsafe-calendar', type: 'branch:request' }
//   родитель → календарь: { source: 'medsafe-calendar', type: 'branch:set', id_branch: 2 }
// Родитель может прислать branch:set и без запроса — например, при смене филиала.

export const MESSAGE_SOURCE = 'medsafe-calendar';

export type ParentMessage = {
  source: typeof MESSAGE_SOURCE;
  type: 'branch:set';
  id_branch: unknown;
};

const referrerOrigin = (): string => {
  try {
    return document.referrer ? new URL(document.referrer).origin : '';
  } catch {
    return '';
  }
};

// Origin родителя: явно из сборки, иначе — откуда открыли iframe
const parentOrigin = process.env.VUE_APP_PARENT_ORIGIN || referrerOrigin();

export const isEmbedded = (): boolean => window.parent !== window;

export const postToParent = (type: string, payload: Record<string, unknown> = {}): boolean => {
  // Без известного origin сообщение не отправляем: '*' отдал бы его любой странице
  if (!isEmbedded() || !parentOrigin) return false;
  window.parent.postMessage({ source: MESSAGE_SOURCE, type, ...payload }, parentOrigin);
  return true;
};

const isParentMessage = (data: unknown): data is ParentMessage => {
  const message = data as ParentMessage | null;
  return !!message && message.source === MESSAGE_SOURCE && message.type === 'branch:set';
};

// Подписка на сообщения родителя; возвращает функцию отписки
export const onParentMessage = (handler: (message: ParentMessage) => void): (() => void) => {
  const listener = (event: MessageEvent) => {
    if (event.source !== window.parent || event.origin !== parentOrigin) return;
    if (isParentMessage(event.data)) handler(event.data);
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
};
